var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-box",class:_vm.shape},[_c('el-image',{staticClass:"avatar",attrs:{"src":_vm.avatarSrc}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{attrs:{"src":_vm.defaultSrc}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }